import axios from 'axios'
const url = '/clientes/cuentacorriente'
export default {

    index(paginacion) {
        return axios.get(url)
    },

    show(id) {

        return axios.get(`${url}/${id}`)
    },

    open(data) {

        return axios.post(`${url}`, data)
    },

    update(data) {
        console.log(data);

        return axios.put(`${url}/${data.id}`, data)
    },


    delete(cliente_id) {
        console.log(cliente_id);
        return axios.delete(`${url}/${cliente_id}`)


    },
    set_habilitado(cliente_id) {
        console.log(cliente_id);
        return axios.get(`${url}/${cliente_id}?habilitar=true`)


    },
    set_tiene_limite_cuenta(cliente_id) {
        console.log(cliente_id);
        return axios.get(`${url}/${cliente_id}?limite_cuenta=true`)


    },
    
    movimientos_cta_cte(cliente_id, paginacion, filtros = {}) {
        const params = {
            c: cliente_id,
            page: paginacion.page,
            page_size: paginacion.rowsPerPage,
        };
        if (filtros.tipo)        params.tipo        = filtros.tipo;
        if (filtros.sucursal)    params.sucursal    = filtros.sucursal;
        if (filtros.fecha_desde) params.fecha_desde = filtros.fecha_desde;
        if (filtros.fecha_hasta) params.fecha_hasta = filtros.fecha_hasta;
        return axios.get('/clientes/cuenta/movimientos', { params });
    },
    getMovimiento(clienteId, movimientoId) {
        return axios.get(`/clientes/${clienteId}/cuentacorriente/movimientos/${movimientoId}`)
    },
    getRecibo(id) {
        return axios.get(`/comprobantes/recibo/${id}`)
    },

    imprimirRecibo(id) {
        return axios.get(`/comprobantes/recibo/${id}/pdf`, { responseType: 'blob' });
    },

    imprimirComprobante(id) {
        return axios.get(`/comprobantes/generate/pdf?q=${id}`, { responseType: 'blob' });
    },

    descargarResumenPDF(cliente_id, filtros = {}) {
        const params = { c: cliente_id };
        if (filtros.fecha_desde) params.fecha_desde = filtros.fecha_desde;
        if (filtros.fecha_hasta) params.fecha_hasta = filtros.fecha_hasta;
        if (filtros.sucursal)    params.sucursal    = filtros.sucursal;
        return axios.get('/clientes/cuenta/resumen-pdf', { params, responseType: 'blob' });
    },

    // Reporte de deuda de toda la empresa (no de un cliente puntual)
    reporte(params = {}) {
        return axios.get('/clientes/reporte/cuentas-corrientes', { params })
    },

    pagar(data) {
        return axios.post('/comprobantes/recibo', data)
    },


}